import { render, staticRenderFns } from "./tradeChance.vue?vue&type=template&id=8cc0f05a&scoped=true&"
import script from "./tradeChance.vue?vue&type=script&lang=js&"
export * from "./tradeChance.vue?vue&type=script&lang=js&"
import style0 from "./tradeChance.vue?vue&type=style&index=0&id=8cc0f05a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cc0f05a",
  null
  
)

export default component.exports